'use strict';

exports.__esModule = true;
exports.AVATAR_SIZE_PX = exports.AVATAR_SIZES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AvatarStyled = require('./AvatarStyled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// Reiner runder Bild-Container (Scope-Entscheid Thomas 2026-06-18, konservativ-
// minimal): KEINE Fallback-/Upload-/isOwnMessage-Logik im Primitiv. `src` rendert
// ein internes <img object-fit:cover>; sonst wird `children` gerendert (Konsument
// liefert LetterAvatar/Icon). Layout/Decor ergaenzt der Konsument via styled(Avatar).
var AVATAR_SIZES = exports.AVATAR_SIZES = { SM: 'sm', MD: 'md', LG: 'lg' };

// React-Wrapper-Pflichtmuster (wie Card.jsx): reicht `className` durch, damit
// Konsumenten via styled(Avatar) ihr Layout ergaenzen koennen.
// styled(Avatar): NICHT `as` an den styled-Wrapper geben (v4 faengt `as` am Wrapper
// ab und ersetzt Avatar selbst -> runde Optik weg). Stattdessen forwardedAs nutzen;
// styled-components reicht es als `as` durch (verifiziert analog Card.jsx).
var Avatar = function Avatar(_ref) {
  var className = _ref.className,
      size = _ref.size,
      src = _ref.src,
      alt = _ref.alt,
      children = _ref.children,
      as = _ref.as,
      rest = _objectWithoutProperties(_ref, ['className', 'size', 'src', 'alt', 'children', 'as']);

  return _react2.default.createElement(
    _AvatarStyled.AvatarBox,
    _extends({ className: className, size: size, as: as }, rest),
    src ? _react2.default.createElement('img', { src: src, alt: alt }) : children
  );
};

Avatar.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(Object.values(AVATAR_SIZES)),
  src: _propTypes2.default.string,
  alt: _propTypes2.default.string,
  children: _propTypes2.default.node,
  as: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.elementType])
} : {};

Avatar.defaultProps = {
  className: undefined,
  size: AVATAR_SIZES.MD,
  src: undefined,
  alt: '',
  children: null,
  as: undefined
};

exports.default = Avatar;
exports.AVATAR_SIZE_PX = _AvatarStyled.AVATAR_SIZE_PX;